import * as THREE from "three";
import type { Point } from "../types/directionsTypes";

export interface RouteBounds {
  center: THREE.Vector3;
  size: THREE.Vector3;
}

export function computeRouteBounds(points: Point[]): RouteBounds | null {
  if (!points?.length) return null;

  const box = new THREE.Box3();

  for (const p of points) {
    // Конвертируем координаты как в RouteLine: [p.x, p.z, -p.y]
    box.expandByPoint(new THREE.Vector3(p.x, p.z, -p.y));
  }

  const center = new THREE.Vector3();
  const size = new THREE.Vector3();
  box.getCenter(center);
  box.getSize(size);

  return { center, size };
}

export function computeSegmentBounds(
  points: Point[],
  segmentPointNames: Set<string>,
): RouteBounds | null {
  const segmentPoints = points.filter((p) => segmentPointNames.has(p.meshName));
  return computeRouteBounds(segmentPoints);
}
